import { loadStripe } from "@stripe/stripe-js";

let stripePromise;
const initializeStripe = async () => {
  if (!stripePromise) {
    const key = (process.env.REACT_APP_STRIPE_PROD_ID || "").trim();
    if (!key) {
      throw new Error(
        "REACT_APP_STRIPE_PROD_ID is missing. Restart the app after fixing .env."
      );
    }
    stripePromise = loadStripe(key);
  }
  return stripePromise;
};
export default initializeStripe;
